import { useMemo } from 'react';
import { api } from '@/redux/api';
import { Group } from '@/types/group';
import { useCurrentOrganisation } from './use-current-organisation';
import { useUserRole } from './use-user-role';

export const useGroups = () => {
  const { organisation, isUsingOrganisationOverride } =
    useCurrentOrganisation();
  const { isPlatformAdmin } = useUserRole();
  const organisationId = organisation?.id ?? -1;

  const result = isPlatformAdmin
    ? api.useGetAllGroupsQuery()
    : api.useGetGroupsQuery(
        { organisationId },
        {
          skip: organisationId === -1,
        },
      );

  const [createGroup] = api.useCreateGroupMutation();
  const [updateGroup] = api.useUpdateGroupMutation();

  const data = useMemo(() => {
    let groups: Group[] = result.data ?? [];

    // If platform admin is using org override, filter groups to that organisation
    if (isPlatformAdmin && isUsingOrganisationOverride && organisation) {
      groups = groups.filter(
        (group) => group.organisation.id === organisation.id,
      );
    }

    return groups;
  }, [result.data, isPlatformAdmin, isUsingOrganisationOverride, organisation]);

  return {
    ...result,
    data,
    createGroup,
    updateGroup,
  };
};
